import { render, staticRenderFns } from "./AdminNotificationDelete.vue?vue&type=template&id=005529bf&scoped=true"
import script from "./AdminNotificationDelete.vue?vue&type=script&lang=js"
export * from "./AdminNotificationDelete.vue?vue&type=script&lang=js"
import style0 from "./AdminNotificationDelete.vue?vue&type=style&index=0&id=005529bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005529bf",
  null
  
)

export default component.exports